import template from './riskInsuranceProducts.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    products: '<',
    contacts: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdMedia, helperService, riskInsuranceService) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.products = ctrl.products || {};
        ctrl.contacts = ctrl.contacts || [];
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.availableRiskInsuranceProductTypes = riskInsuranceService.getAvailableRiskInsuranceProductTypes();
        ctrl.isReady = true;
      };

      ctrl.riskInsuranceProductAdd = (productType) => {
        riskInsuranceService.riskInsuranceProductAdd(ctrl.products, productType);
      };

      ctrl.riskInsuranceProductDelete = (product) => {
        const idx = _.findIndex(ctrl.products || [], (p) => p?.id === product?.id);
        if (idx > -1) {
          ctrl.products = riskInsuranceService.riskInsuranceProductDelete(ctrl.products, idx);
          ctrl.saveRiskInsuranceProducts();
        }
      };

      ctrl.getLastIndex = (data, type) => helperService.getLastIndex(data, type);

      ctrl.saveRiskInsuranceProducts = _.debounce((product) => {
        if (product) {
          const idx = _.findIndex(ctrl.products || [], (p) => p?.id === product?.id);
          if (idx > -1) {
            ctrl.products.splice(idx, 1);
            ctrl.products.splice(idx, 0, product);
          } else {
            ctrl.products.push(product);
          }
        }
        ctrl.onFinished({ products: ctrl.products });
      }, 2000);

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
